import React, { useRef } from "react";
import { mapDispatchProps, mapStateToProps } from "../../../../store/store";
import { connect } from "react-redux";
import Button from "../../../../components/button";
import { X } from "react-feather";
import API from "../../../../api";
import { debounce } from "../../../../helpers/debounce";
import SnsPaymentCancelComplete from "./complete";
import dayjs from "../../../../plugins/dayjs";
import { useLanguage } from '@languages/index';

const SnsPaymentCancelConfirm = (props: any) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };
  const lastCampaignEndsAt = useRef(dayjs(props.brand.lastCampaignEndsAt));
  const lastSeedingPassEndsAt = useRef(
    dayjs(props.brand.lastSeedingPassEndsAt)
  );

  const showCancelComplete = () => {
    props.closeOverlays();
    debounce(() => {
      props.showOverlays({
        content: () => {
          return <SnsPaymentCancelComplete />;
        },
      });
    }, 400);
  };

  const offAutoPurchase = () => {
    API.Brand.update({
      brandToken: props.auth.token,
      isSnsPassAutoPurchaseEnabled: "false",
    })
      .then((response) => {
        let arr = {
          text: response.data.message,
        };

        if (response.data.title.length) {
          arr["title"] = response.data.title;
        }

        showCancelComplete();
      })
      .catch((error) => {
        props.setPopup({
          isVisible: true,
          text: error.message,
        });
      });
  };

  return (
    <div className="flex flex-col bg-white py-10 px-5 md:rounded-2xl min-w-[100vw] md:min-w-[480px] md:max-w-[480px] md:px-10 md:py-10">
      <div className="flex flex-col">
        <div
          className=" cursor-pointer flex flex-row justify-end"
          onClick={() => {
            props.closeOverlays();
          }}
        >
          <X size={24} />
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col pb-2 mb-10">
            <div className="flex flex-col gap-6">
              <span className="font-bold text-[28px] tracking-tighter text-start">
                {languageTexts.payments_bills_text_3}
              </span>

              <span className="text-base tracking-tighter text-start">
                {languageTexts._payments_cancel_complete_text_3(props.brand.lastSnsPassEndsAt)}
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <Button
            buttonColor="BLACK"
            textColor="WHITE"
            text={languageTexts.payments_cancel_complete_text_4}
            onClick={() => {
              props.closeOverlays();
            }}
          />
          <Button
            text={languageTexts.payments_cancel_complete_text_5}
            onClick={() => {
              offAutoPurchase();
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default connect(
  mapStateToProps,
  mapDispatchProps
)(SnsPaymentCancelConfirm);
